import cn from 'classnames'
import Router from 'next/router'

import { Container } from '@components/Container'
import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { ChapterPageContainerProps } from './interface'

export function ChapterPageContainer({
  className,
  theme,
  children,
}: ChapterPageContainerProps) {
  return (
    <Container className={className}>
      <div
        className={cn(
          'pt-[50px] px-[60px] border tablet-mobile:pt-[21px] tablet-mobile:px-[21px] bg-white dark:bg-dark desktop:rounded-lg',
          {
            'border-gray-4': theme === ThemeEnum.LIGHT,
            'bg-sepia border-sepia-1': theme === ThemeEnum.SEPIA,
            '!bg-dark-5':
              theme === ThemeEnum.DARK &&
              Router.pathname === '/story/[id]/chapter/[chapterId]',
          }
        )}
      >
        {children}
      </div>
    </Container>
  )
}
